/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ paid: NonNullable<unknown>, total: NonNullable<unknown> }} Payment_SummaryInputs */



/**
* | output |
* | --- |
* | "{paid}/{total} paid" |
*
* @param {Payment_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const payment_summary = /** @type {((inputs: Payment_SummaryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_SummaryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.paid}/${i?.total} payé(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.paid}/${i?.total} pagado(s)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.paid}/${i?.total} pago(s)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.paid}/${i?.total} pagato/i`)
	return /** @type {LocalizedString} */ (`${i?.paid}/${i?.total} paid`)
});